<template>
    <div>
        <form @submit.prevent="login">
            <div class="u-margin-bottom u-text-center">
                <div class="u-text-left">
                    <text-input
                        v-model="form.username"
                        :error="form.errors.first('username')"
                        :label="trans('authentication.login.email-label')"
                        name="username"
                        class="field__label--authentication field__input--authentication | u-full-width"
                        required
                        focus
                    />
                </div>

                <div class="u-text-left">
                    <password-input
                        v-model="form.password"
                        :error="form.errors.first('password')"
                        :label="trans('authentication.login.password-label')"
                        name="password"
                        class="field__label--authentication field__input--authentication | u-full-width"
                        required
                    />
                </div>

                <div class="u-text-left" v-if="form.errors.first('two_factor_code')">
                    <text-input
                        v-model="form.two_factor_code"
                        :error="form.errors.first('two_factor_code')"
                        :label="trans('authentication.login.two-factor-code-label')"
                        name="two_factor_code"
                        class="field__label--authentication field__input--authentication | u-full-width"
                        required
                        focus
                    />
                </div>
            </div>

            <nav class="u-text-center">
                <button class="btn btn--auth | u-margin-bottom-narrow u-full-width" dusk="login-button" type="submit">
                    {{ trans('authentication.login.button') }}
                </button>
                <div class="authentication__form-links">
                    <router-link v-if="register" :to="{ name: 'register' }" class="u-margin-right">
                        {{ trans('authentication.login.register') }}
                    </router-link>
                    <router-link :to="{ name: 'passwordReset' }" class="u-margin-left">
                        {{ trans('authentication.login.forgot-password') }}
                    </router-link>
                </div>
            </nav>
        </form>
    </div>
</template>

<script>
import { Way2Form } from 'relapp-way2forms';

export default {
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                username: null,
                password: null,
                two_factor_code: ''
            })
        };
    },
    props: {
        register: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        /**
         * Submit login form
         */
        login() {
            this.$emit('submit', this.form);
        }
    }
};
</script>
